import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserDefinedDataType } from '@core/enums/user-defined-data-type.enum';
import { UserDefinedField } from '@core/models/shared/user-defined-field.model';
import { SharedComponentsSysTextService } from '@core/services/shared-components-sys-text.service';

@Component({
    selector: 'app-user-defined-read-only',
    templateUrl: './user-defined-read-only.component.html',
    styleUrl: './user-defined-read-only.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserDefinedReadOnlyComponent implements OnInit {
  static readonly componentName = 'UserDefinedReadOnlyComponent';

  @Input() userDefinedField: UserDefinedField;
  public dataType = UserDefinedDataType;
  public sysText: any;

  constructor(private text: SharedComponentsSysTextService) {}

  ngOnInit(): void {
    // only needed for the info button's name ("more information"): this component has no text section
    // of its own, so it borrows the shared input field's, which has that key
    this.sysText = this.text.sysText[this.text.templates.inputField];
  }
}
